export default "__VITE_ASSET__63af1413__"